export const ProfileStatus = {
    GUEST: "GUEST",
    OWNER: "OWNER",
    NEED_UPDATE: "NEED_UPDATE"
}